import React from 'react';
import { withSvgWrap } from "../icons/SvgWrap";
import { LOADER_SIZES } from "./types";
var LoaderIconPlain = withSvgWrap('m15.36 2.64-1.41 1.41A7 7 0 1 0 16 9h2a9 9 0 1 1-2.64-6.36z', {
  viewBox: '0 0 18 18'
});
export var LoaderIcon = function LoaderIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size;
  return /*#__PURE__*/React.createElement(LoaderIconPlain, {
    size: LOADER_SIZES[size],
    "data-t-id": "src-Preloader"
  });
};